import { useQuery } from 'react-query';

import { ENDPOINT_CARTS } from '@/common/constants';
import getCarts from '@/ebat/api/carts/getCarts';

const useCarts = ({
  editherm,
  user,
  hasProducts,
  onSuccess,
  sources,
  isLoggedIn,
}) =>
  useQuery(
    [
      ENDPOINT_CARTS,
      editherm ?? false,
      user,
      hasProducts ?? false,
      sources ?? null,
    ],
    getCarts,
    {
      enabled: !!isLoggedIn,
      keepPreviousData: true,
      onSuccess,
    },
  );

export default useCarts;
